import React from 'react'
import { MainSectionDefault, Section } from './views/includes/Wrappers'

const BrowserNotSupportedPage = () => {
    return (
        <div className="browser-not-supported-page--wrapper">
            <section className="logo--section">
                <Section>
                    <div className="logo">
                        <img
                            className="center"
                            alt="LiftOne Now"
                            src="/img/logo/liftonenow_logo.svg"
                        />
                    </div>
                </Section>
            </section>

            <MainSectionDefault>
                <h1 className="h3 text-center">Update Your Browser</h1>
                <p>Your browser is no longer supported.</p>
                <p>
                    To access your account in LiftOne Now, please use the newest
                    version of one of our supported browsers:
                </p>
                <ul>
                    <li>
                        <a href="https://www.google.com/intl/us-419/chrome/">
                            Google Chrome
                        </a>
                    </li>

                    <li>
                        <a href="https://www.mozilla.org/en-US/firefox/new/">
                            Mozilla Firefox
                        </a>
                    </li>

                    <li>
                        <a href="https://support.apple.com/downloads/safari">
                            Safari
                        </a>
                    </li>

                    <li>
                        <a href="https://www.opera.com/download">Opera</a>
                    </li>

                    <li>
                        <a href="https://www.microsoft.com/en-us/edge">
                            Microsoft Edge
                        </a>
                    </li>
                </ul>
                <p>
                    If you already have one of these browsers installed, just
                    open it and visit www.liftonenow.com.
                </p>
            </MainSectionDefault>
        </div>
    )
}

export default BrowserNotSupportedPage
